import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import NftCard from "../../components/NftCard";
import ApiService from "../../services/api-service";
import notifier from "../../components/Notifier";
import { getErrorString, getUserId } from "../../constants/function";
import DefaultNft from "../../assets/common/resources/DefaultNft.svg"; // Default image for NFTs

const Top3Nfts = ({ loading, nfts }) => {
  const [topNfts, setTopNfts] = useState([]);
  const userId = getUserId();
  const pageNo = 1;

  // Function to fetch the top NFTs
  const getMusicNft = async () => {
    try {
      const response = await ApiService.MOSTEXPENSIVE({
        userId: userId,
        pageSize: 3, // Limit to 3 NFTs
        pageNo: pageNo,
      });

      const sortedNfts = response["result"]
        .sort((a, b) => b.streamingCount - a.streamingCount)
        .slice(0, 3); // Take only the top 3

      setTopNfts(sortedNfts);
    } catch (error) {
      notifier.error(getErrorString(error));
    }
  };

  useEffect(() => {
    getMusicNft();
  }, []);

  // Render the number behind each NFT card
  const renderNumber = (index) => (
    <Typography
      sx={{
        position: "relative",
        margin: "-30px",
        top: "55%", 
        left: "-30%", // Push it to the left relative to the card
        fontSize: "200px", // Number size
        fontWeight: "bold",
        color: "transparent", // Hollow text
        WebkitTextStroke: "2px #ffcc00", // Yellow outline
        zIndex: 1, // Behind the card
        transform: "translateY(-50%)", // Center vertically
        pointerEvents: "none", // Make sure the number doesn't interfere with card interaction
      }}
    >
      {index + 1}
    </Typography>
  );

  const loadingPlaceholder = new Array(3).fill({
    title: "Loading...",
    artist: "Loading...",
    thumbnailImg: { filePath: DefaultNft },
    streamingCount: 0,
  });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        backgroundColor: "var(--background-color, black)",
        boxSizing: "border-box",
        overflow: "visible",
      }}
    >
      <Typography variant="h4" sx={{ fontWeight: "bold", marginBottom: "10px" }}>
        Top 3 NFTs
      </Typography>

      {(loading ? loadingPlaceholder : topNfts).map((nftItem, index) => (
        <Box key={`${nftItem._id}-${index}`} className="nft-card"
          sx={{
            display: "flex", 
            justifyContent: "center", 
            alignItems: "center",
            width: "100%",
            position: "relative",
          }}
        >
          {/* Render the large number aligned to the edge of the card */}
          {renderNumber(index)}

          {/* NFT Card container */}
          <Box
            sx={{
              transform: "scale(0.6)", // Adjust the card size (60% smaller)
              transformOrigin: "center", // Keep the card centered
              position: "absolute",
              zIndex: 2,
              boxSizing: "border-box",
            }}
          >
            <NftCard nft={nftItem} /> {/* Corrected from 'nft' to 'nftItem' */}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default Top3Nfts;
